/* eslint-disable no-template-curly-in-string */
// Reference FPTI's : https://engineering.paypalcorp.com/confluence/pages/viewpage.action?pageId=560119786

export const trackerFPTIs = {
  refundTracker: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:refund-tracker',
    comp: 'smarthelpnodeweb',
  },
  disputeTracker: {
    page: 'main:help:center::dispute-tracker:::',
    pgrp: 'main:help:center:home',
  },
};

export const topicTreeFPTIs = {
  topicTreeSuccess: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:topic-tree',
    e: 'ac',
    event_name: 'topic_tree_shown_home_page_help_center',
  },
  topicTreeError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:topic-tree-error',
    e: 'ac',
    event_name: 'topic_tree_error_home_page_help_center',
  },
  topicTreeNoDataReceived: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:topic-tree-no-data',
    e: 'ac',
    event_name: 'topic_tree_no_data_received_home_page_help_center',
  },
  topicTreeClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:topic-tree',
    e: 'cl',
    link: 'topicTree|${topicId}',
    event_name: 'topic_tree_clicked_home_page_help_center',
  },
};

export const communityFPTIs = {
  communityModuleSuccess: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:community-banner',
    e: 'ac',
    event_name: 'community_banner_shown_home_page_help_center',
  },
  communityModuleError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:community-banner-error',
    e: 'ac',
    event_name: 'community_banner_error_home_page_help_center',
  },
  communityModuleClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:community-banner',
    e: 'cl',
    link: 'community-banner-clicked',
    event_name: 'community_banner_clicked_home_page_help_center',
  },
};

export const extendedFooterFPTIs = {
  extendedFooterSuccess: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:extended-footer',
    e: 'ac',
    event_name: 'extended_footer_shown_home_page_help_center',
  },
  extendedFooterError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:extended-footer-error',
    e: 'ac',
    event_name: 'extended_footer_error_home_page_help_center',
  },
  extendedFooterRedirectError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:extended-footer-error',
    e: 'ac',
    event_name: 'extended_footer_${channelName}_redirect_error_home_page_help_center',
  },
  extendedFooterClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:extended-footer',
    e: 'cl',
    link: '${channelName}|extended-footer-link',
    event_name: 'extended_footer_link_clicked_${channelName}_home_page_help_center',
  },
};

export const recommendedGuidesFPTIs = {
  recGuidesSuccess: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-guides',
    e: 'ac',
    event_name: 'recommended_guides_shown_home_page_help_center',
  },
  recGuidesError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-guides-error',
    e: 'ac',
    event_name: 'recommended_guides_error_home_page_help_center',
  },
  recGuidesOnClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-guides',
    e: 'cl',
    link: '${icfId}|recommended-guide',
    event_name: 'recommended_guide_clicked_home_page_help_center',
  },
  recGuidesButtonClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-guides',
    e: 'cl',
    link: 'recommended_guides_see_all_guides_button_clicked',
    event_name: 'recommended_guides_see_all_guides_clicked_home_page_help_center',
  },
  recGuidesTryAgainClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-guides-error',
    e: 'cl',
    link: 'recommended_guides_try_again_link_clicked',
    event_name: 'recommended_guides_try_again_on_error_clicked_home_page_help_center',
  },
};

export const recommendedAnswersFPTIs = {
  recAnswersSuccess: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-answers',
    e: 'ac',
    event_name: 'recommended_answers_shown_home_page_help_center',
  },
  recAnswersError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-answers-error',
    e: 'ac',
    event_name: 'recommended_answers_error_home_page_help_center',
  },
  recAnswersOnClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-answers',
    e: 'cl',
    link: '${articleId}|recommended-answer',
    event_name: 'recommended_answer_clicked_home_page_help_center',
  },
  recAnswersTryAgainClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:recommended-answers-error',
    e: 'cl',
    link: 'recommended_answers_try_again_link_clicked',
    event_name: 'recommended_answers_try_again_on_error_clicked_home_page_help_center',
  },
};

// NNA widget
export const nnaWidgetFPTIs = {
  nnaWidgetSuccess: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:nna-widget',
    e: 'ac',
    event_name: 'nna_widget_shown_home_page_help_center',
  },
  nnaWidgetError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:nna-widget-error',
    e: 'ac',
    event_name: 'nna_widget_error_home_page_help_center',
  },
  nnaWidgetButtonClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:nna-widget',
    e: 'cl',
    link: 'nna-widget-get-started-button|${icfId}',
    event_name: 'nna_widget_get_started_button_clicked_home_page_help_center',
  },
};

// Personalized Section
export const personalizedWidgetFPTIs = {
  personalizedWidgetLoggedOut: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget',
    e: 'ac',
    event_name: 'personalized_widget_logged_out_shown_home_page_help_center',
  },
  personalizedWidgetLoggedInNoData: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget',
    e: 'ac',
    event_name: 'personalized_widget_logged_in_no_data_shown_home_page_help_center',
  },
  personalizedWidgetOcpShown: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget',
    e: 'ac',
    event_name: 'personalized_widget_ocp_shown_home_page_help_center',
  },
  personalizedWidgetOcpLinkClicked: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget',
    link: 'ocp-prompt-clicked|${intentId}',
    e: 'cl',
    event_name: 'personalized_widget_ocp_link_clicked_home_page_help_center',
  },
  personalizedWidgetRefundTrackersInfoShown: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget',
    e: 'ac',
    event_name: 'personalized_widget_refund_trackers_info_shown_home_page_help_center',
  },
  personalizedWidgetDisputeTrackersInfoShown: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget',
    e: 'ac',
    event_name: 'personalized_widget_dispute_trackers_info_shown_home_page_help_center',
  },
  personalizedWidgetRefundTrackersSeeAllBtn: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget',
    e: 'cl',
    link: 'personalized-widget-refund-trackers-see-all-button-clicked',
    event_name: 'personalized_widget_refund_trackers_see_all_btn_clicked_home_page_help_center',
  },
  personalizedWidgetDisputeTrackersSeeAllBtn: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget',
    e: 'cl',
    link: 'personalized-widget-dispute-trackers-see-all-button-clicked',
    event_name: 'personalized_widget_dispute_trackers_see_all_btn_clicked_home_page_help_center',
  },
  personalizedWidgetError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:personalized-widget-error',
    e: 'ac',
    event_name: 'personalized_widget_error_home_page_help_center',
  },
};

// Trackers Sheet
export const trackersSheetFPTIs = {
  trackersSheetOpen: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:trackers-sheet',
    e: 'ac',
    event_name: 'trackers_sheet_shown_home_page_help_center',
  },
  trackersSheetClose: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:trackers-sheet',
    link: 'smarthelp-tracker-sheet|close',
    e: 'cl',
    event_name: 'trackers_sheet_closed_home_page_help_center',
  },
  trackersSheetRefundsAccordianOnClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:trackers-sheet',
    e: 'cl',
    link: 'trackers-sheet-refunds-accordian-clicked',
    event_name: 'trackers_sheet_refunds_accordian_clicked_home_page_help_center',
  },
  trackersSheetDisputesAccordianOnClick: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:trackers-sheet',
    e: 'cl',
    link: 'trackers-sheet-disputes-accordian-clicked',
    event_name: 'trackers_sheet_disputes_accordian_clicked_home_page_help_center',
  },
};

export const searchBarFPTIs = {
  fullSearch: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'cl',
    link: 'smarthelp-full-search-clicked',
    event_name: 'full_search_clicked_home_page_help_center',
  },
  allResultsSearch: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'cl',
    link: 'smarthelp-view-all-results-full-search-clicked',
    event_name: 'view_all_results_full_search_clicked_home_page_help_center',
  },
  autoSuggestionEmptyResponse: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'ac',
    event_name: 'auto_suggestion_search_empty_response_home_page_help_center',
  },
  autoSuggestionError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'ac',
    event_name: 'auto_suggestion_search_error_response_home_page_help_center',
  },
  autoSuggestionClicked: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'cl',
    link: 'smarthelp-auto-suggestion-article-clicked|${articleTitle}|${searchQuery}|${articleId}|index-${index}|total-${totalResults}',
    event_name: 'auto_suggestion_article_clicked_home_page_help_center',
  },
  topContactReasonsSuggestionClicked: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'cl',
    link: 'smarthelp-top-contact-reason-suggestion-article-clicked|${articleTitle}|${articleId}|index-${index}',
    event_name: 'top_contact_reason_suggestion_article_clicked_home_page_help_center',
  },
  searchQueryReset: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'cl',
    link: 'smarthelp-search-query-cleared',
    event_name: 'search_query_clear_button_clicked_home_page_help_center',
  },
  customTopContactReasonsDisplayed: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'ac',
    event_name: 'custom_top_contact_reason_suggestion_displayed_home_page_help_center',
  },
  customTopContactReasonsSuggestionClicked: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'cl',
    link: 'smarthelp-custom-top-contact-reason-suggestion-article-clicked|${articleTitle}|${articleId}|index-${index}',
    event_name: 'custom_top_contact_reason_suggestion_article_clicked_home_page_help_center',
  },
  searchBarFocusedInhome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'cl',
    link: 'smarthelp-search-bar-focused',
    event_name: 'search_bar_focused_home_page_help_center',
  },
  searchBarCommonQuestionsDisplayedInhome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:search',
    e: 'ac',
    event_name: 'quicklinks_for_common_questions_displayed_home_page_help_center',
  },
};

// set-context for home page
export const setContextFPTIhome = {
  setContexthome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:set-context',
    context_status: 'ACTIVE',
    channel_name: 'HELP_CENTER',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_fired',
  },
  setContextSuccesshome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:set-context-success',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_success',
  },
  setContextFailurehome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:set-context-failed',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_failed',
  },
  setContextNotFiredhome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:omni-channel-set-context-not-fired',
    e: 'ac',
    event_name: 'classic_help_ocp_set_context_not_fired',
  },
};

// update-context for home page
export const updateContextFPTIhome = {
  updateContexthome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:update-context',
    context_status: 'ACTIVE',
    channel_name: 'HELP_CENTER',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_fired',
  },
  updateContextSuccesshome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:update-context-success',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_success',
  },
  updateContextFailurehome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:update-context-failed',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_failed',
  },
  updateContextNotFiredhome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:omni-channel-update-context-not-fired',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_not_fired',
  },
  updateContextFailureNullIcfIdhome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:update-context-failed-null-icf-id',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_failed_null_icf_id',
  },
};

// update-context for contactUs page
export const updateContextFPTIcontactUs = {
  updateContextcontactUs: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:update-context',
    context_status: 'ACTIVE',
    channel_name: 'HELP_CENTER',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_fired',
  },
  updateContextSuccesscontactUs: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:update-context-success',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_success',
  },
  updateContextFailurecontactUs: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:update-context-failed',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_failed',
  },
  updateContextNotFiredcontactUs: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:omni-channel-update-context-not-fired',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_not_fired',
  },
  updateContextFailureNullIcfIdcontactUs: {
    pgrp: 'main:help:center:contact-us',
    page: 'main:help:center:update-context-failed-null-icf-id',
    e: 'ac',
    event_name: 'classic_help_ocp_update_context_failed_null_icf_id',
  },
};

// qualtrics feedback
export const qualtricsFeedbackPanelFPTI = {
  qualtricsFeedbackShown: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:qualtrics-footer-survey',
    e: 'ac',
    event_name: 'qualtrics_survey_shown_in_home_page',
  },
  qualtricsFeedbackClicked: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:qualtrics-footer-survey',
    e: 'cl',
    link: 'smarthelp-footer-survey',
    event_name: 'qualtrics_survey_clicked_in_home_page',
  },
  qualtricsFeedbackError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:qualtrics-footer-survey-error',
    e: 'ac',
    event_name: 'qualtrics_survey_error_in_home_page',
  },
  qualtricsFeedbackOnClickError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:qualtrics-footer-survey-error',
    e: 'ac',
    event_name: 'qualtrics_survey_on_click_error_in_home_page',
  },
};

export const customerJourneyAPIFPTI = {
  customerJourneyAPICalled: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:customer-journey',
    e: 'ac',
    link: 'smarthelp-customer-journey-api-fired',
    event_name: 'classic_help_customer_journey_api_fired',
  },
  customerJourneyAPISuccess: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:customer-journey-api-success',
    e: 'ac',
    link: 'smarthelp-customer-journey-api-success',
    event_name: 'classic_help_customer_journey_api_success',
  },
  customerJourneyFailure: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:customer-journey-api-failed',
    e: 'ac',
    link: 'smarthelp-customer-journey-api-failed',
    event_name: 'classic_help_customer_journey_api_failed',
  },
};
// update-context for home page
export const updateBNAFPTIhome = {
  updateBNAhome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:update-bna',
    e: 'ac',
    link: 'update-bna-api-fired',
    event_name: 'classic_help_ocp_update_bna_fired',
  },
  updateBNASuccesshome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:update-bna-success',
    e: 'ac',
    link: 'update-bna-api-success',
    event_name: 'classic_help_ocp_update_bna_success',
  },
  updateBNAFailurehome: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:update-bna-failed',
    e: 'ac',
    link: 'update-bna-api-failed',
    event_name: 'classic_help_ocp_update_bna_failed',
  },
};
// auth confirmation prompt
export const authConfirmationPromptFPTI = {
  authPromptOnClickClose: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:confirm-auth-prompt',
    e: 'cl',
    link: 'confirm-auth-prompt-close-clicked',
    event_name: 'confirm_auth_stepup_prompt_close_clicked_in_home_page',
  },
  authPromptOnClickYes: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:confirm-auth-prompt',
    e: 'cl',
    link: 'confirm-auth-prompt-yes-clicked',
    event_name: 'confirm_auth_stepup_prompt_yes_clicked_in_home_page',
  },
  authPromptOnClickNo: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:confirm-auth-prompt',
    e: 'cl',
    link: 'confirm-auth-prompt-no-clicked',
    event_name: 'confirm_auth_stepup_prompt_no_clicked_in_home_page',
  },
  authPromptShown: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:confirm-auth-prompt',
    e: 'ac',
    event_name: 'confirm_auth_stepup_prompt_shown_in_home_page',
  },
  authPromptError: {
    pgrp: 'main:help:center:home',
    page: 'main:help:center:confirm-auth-prompt-error',
    e: 'ac',
    event_name: 'confirm_auth_stepup_prompt_error_in_home_page',
  },
};
